export default __webpack_public_path__ + "static/media/shiftWiseIcon.ed858257.svg";